import { DEFAULT_PAGE_SIZE } from 'config/constants';
import { Maybe } from 'graphql/generated';
import { useCurrentPageQuery } from 'helpers/queryParams/useCurrentPageQuery';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { useEffect, useRef } from 'react';
import { FriendlyUrlPageType } from 'types/friendlyUrl';
import { ListedProductType } from 'types/product';
import { getGtmProductsListEvent, getNewGtmEcommerceEvent } from 'utils/Gtm/EventFactories';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmBrandProductListView = (
    data: Maybe<FriendlyUrlPageType> | undefined,
    slug: string,
    products: ListedProductType[],
    fetching: boolean,
): void => {
    const lastViewedBrandSlug = useRef<string | undefined>(undefined);
    const lastViewedBrandPage = useRef<number | undefined>(undefined);
    const currentPage = useCurrentPageQuery();
    const { url } = useDomainConfig();

    useEffect(() => {
        if (
            data !== null &&
            data !== undefined &&
            data.__typename === 'Brand' &&
            (lastViewedBrandSlug.current !== slug || lastViewedBrandPage.current !== currentPage) &&
            !fetching
        ) {
            lastViewedBrandSlug.current = slug;
            lastViewedBrandPage.current = currentPage;
            const event = getNewGtmEcommerceEvent('ec.products_list', true);
            event.ecommerce = getGtmProductsListEvent(products, 'brand', currentPage, DEFAULT_PAGE_SIZE, url);
            gtmSafePushEvent(event);
        }
    }, [data, fetching, currentPage, products, slug, url]);
};
